import { useState, useEffect } from 'react';

import { isPrerendering } from '../services/api';

import { Card } from './ui/card';

const LineagePage = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(!isPrerendering());

  useEffect(() => {
    // Skip API calls during pre-rendering (react-snap)
    if (isPrerendering()) return;

    fetchSections();
  }, []);

  const fetchSections = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/lineage`);
      if (response.ok) {
        const data = await response.json();
        setSections(data);
      }
    } catch (error) {
      console.error('Failed to load lineage');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center p-20">Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      {/* Hero Banner */}
      <section className="bg-gradient-to-r from-red-600 to-red-700 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Our Lineage & History
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto">
              Centuries of tradition, dedication, and martial arts excellence
            </p>
          </div>
        </div>
      </section>

      {/* Lineage Sections */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="space-y-20">
            {sections.map((section, index) => (
              <div key={section.id} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}>
                {/* Image */}
                {section.image_url && (
                  <div className="lg:w-1/2">
                    <Card className="overflow-hidden shadow-2xl">
                      <img 
                        src={section.image_url} 
                        alt={section.title}
                        className="w-full h-auto object-cover"
                      />
                    </Card>
                  </div>
                )}

                {/* Content */}
                <div className={section.image_url ? 'lg:w-1/2' : 'w-full max-w-4xl mx-auto'}>
                  <div className="space-y-6">
                    <div>
                      <h2 className="text-4xl font-bold text-gray-900 mb-4">
                        {section.title}
                      </h2>
                      {section.quote && (
                        <div className="bg-red-50 border-l-4 border-red-600 p-4 mb-6">
                          <p className="text-lg italic text-gray-800">
                            "{section.quote}"
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="prose prose-lg max-w-none">
                      {section.content.split('\n\n').map((paragraph, idx) => (
                        <p key={idx} className="text-gray-700 leading-relaxed mb-4">
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default LineagePage;
